/**
 * @returns true if the passed pincode in string format is valid
 */
export const checkIsValidIndianPincode = (pincode?: string) =>
    // check if the pincode is in correct format
    // 1st digit can be 1-9 and remaining 5 digits can be 0-9
    typeof pincode === "string" && /^[1-9][0-9]{5}$/.test(pincode);
